const addPriceUnderImgThumbs = () => {
  const pricings = {};
  CPB.getStore().getState().Product.panels.forEach(p => {
    p.categories.forEach(c => {
      if (c.display != 'img') return
      c.options.forEach(o => {
        pricings[o.id] = `${o.price} $`;
      });
    });
  });

  console.log(pricings);

  const updateProps = () => {
    for (let optionId in pricings) {
      const priceString = pricings[optionId];
      const optionElems = document.querySelectorAll(`.cpb-option[data-option-id="${optionId}"]`);
      optionElems.forEach(elem => {
        if (!elem) return
        elem.dataset.priceString = priceString;
      })
    };
  };

  document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', updateProps)
};


document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function(event) {
  addPriceUnderImgThumbs();
})